import script from "./RedirectBack.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirectBack.vue?vue&type=script&setup=true&lang=js"

import "./RedirectBack.vue?vue&type=style&index=0&id=eaa3bd52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa3bd52"]])

export default __exports__